import React from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import { createLowlight } from 'lowlight';

// Import enhanced syntax highlighting styles
import '../../styles/syntax-highlighting.css';

// Create lowlight instance
const lowlight = createLowlight();

// Import common languages for syntax highlighting
import javascript from 'highlight.js/lib/languages/javascript';
import typescript from 'highlight.js/lib/languages/typescript';
import python from 'highlight.js/lib/languages/python';
import css from 'highlight.js/lib/languages/css';
import xml from 'highlight.js/lib/languages/xml';
import json from 'highlight.js/lib/languages/json';
import bash from 'highlight.js/lib/languages/bash';
import c from 'highlight.js/lib/languages/c';
import cpp from 'highlight.js/lib/languages/cpp';
import x86asm from 'highlight.js/lib/languages/x86asm';


// Register languages with lowlight
lowlight.register('javascript', javascript);
lowlight.register('typescript', typescript);
lowlight.register('python', python);
lowlight.register('css', css);
lowlight.register('html', xml);
lowlight.register('xml', xml);
lowlight.register('json', json);
lowlight.register('bash', bash);
lowlight.register('c', c);
lowlight.register('cpp', cpp);
lowlight.register('c++', cpp);
lowlight.register('asm', x86asm);
lowlight.register('assembly', x86asm);

const TiptapDisplay = ({ content }) => {
  const editor = useEditor({
    extensions: [
      StarterKit.configure({
        codeBlock: false,
      }),
      CodeBlockLowlight.configure({
        lowlight,
        defaultLanguage: 'cpp',
      }),
      Image.configure({
        HTMLAttributes: {
          class: 'max-w-full h-auto rounded-lg',
        },
      }),
      Link.configure({
        openOnClick: true, // Allow clicking links in display mode
        HTMLAttributes: {
          class: 'text-blue-400 hover:text-blue-300 transition-colors cursor-pointer',
          rel: 'noopener noreferrer',
          target: '_blank', // Open links in new tab
        },
      }),
    ],
    content: content || '',
    editable: false,
    editorProps: {
      attributes: {
        class: 'prose prose-invert max-w-none focus:outline-none text-slate-200',
      },
    },
  });

  if (!editor) {
    return null;
  }

  return (
    <div className="tiptap-display">
      <EditorContent editor={editor} />
    </div>
  );
};

export default TiptapDisplay;